import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'deal-crawlers';

export type CruiseDealCrawler = definitions['DEAL_CRAWLER'];
export type CruiseDealSailingCrawler = definitions['DEAL_SAILING_CRAWLER_WITH_DEPARTURE'];

const crawlDealPage = async (sourceUrl: string): Promise<CruiseDealCrawler> => {
  const response = await cruisesAPI.http.post<API.Response<CruiseDealCrawler>>({
    resource: `${resource}/crawl`,
    body: {
      sourceUrl,
    },
  });

  return response.result;
};

const listWithPagination = (
  paginationParams: API.PaginationParams,
): Promise<API.Response<Array<CruiseDealCrawler>>> => {
  return cruisesAPI.http.get({ resource, paginationParams }, undefined);
};

const getById = (id: string): Promise<API.Response<CruiseDealCrawler>> => {
  return cruisesAPI.http.get({ resource: `${resource}/${id}` });
};

const deleteById = (id: string): Promise<API.Response<CruiseDealCrawler>> => {
  return cruisesAPI.http.delete({ resource: `${resource}/${id}` });
};

const getSailings = (
  id: string,
  paginationParams?: API.PaginationParams,
): Promise<API.Response<Array<CruiseDealSailingCrawler>>> => {
  return cruisesAPI.http.get({
    resource: `${resource}/${id}/sailings`,
    paginationParams: paginationParams || {},
  });
};

export default {
  crawlDealPage,
  listWithPagination,
  getById,
  deleteById,
  getSailings,
};
